export const SkeletonSwiperContent = () => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className="animate-pulse">
                    <div className="bg-gray-200 aspect-[16/10] rounded-lg mb-3"></div>
                    <div className="h-3 bg-gray-200 rounded w-1/3 mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-full mb-1"></div>
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                    <div className="h-3 bg-gray-200 rounded w-1/4 mt-2"></div>
                </div>
            ))}
        </div>
    )
}